<template>
  <div class="sort">
    <IconArrow class="arrow top" :class="{ active: sort === filter }" @click="editSort(filter)" />
    <IconArrow class="arrow bottom" :class="{ active: sort === `-${filter}` }" @click="editSort(`-${filter}`)" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
    },

    filter: {
      type: String,
    },
  },

  data() {
    return {
      sort: '',
    };
  },

  watch: {
    value(value) {
      this.sort = value;
    },
  },

  mounted() {
    this.sort = this.value;
  },

  methods: {
    editSort(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.sort {
  display: flex;
  flex-direction: column;
  margin: 0 8px 0 5px;
  flex-shrink: 0;

  .arrow {
    width: 10px;
    opacity: 0.4;
    cursor: pointer;
    transition: 0.3s;

    &.top {
      transform: rotate(90deg);
    }
    &.bottom {
      transform: rotate(-90deg);
      margin-left: 1px;
    }

    &.active {
      opacity: 1;
    }
  }
}
</style>
